/**
 * @generated SignedSource<<cb272f84bdaefdd6ad76f5368c3fa8cd>>
 * @relayHash 959277dc198c5bb93ab2d634950ec771
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 959277dc198c5bb93ab2d634950ec771

import { ConcreteRequest } from 'relay-runtime';
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type chDuplicatePatientsByPatientIdQuery$variables = {
  patientId: string;
};
export type chDuplicatePatientsByPatientIdQuery$data = {
  readonly ch_duplicatePatientsByPatientId: ReadonlyArray<{
    readonly displayId: number;
    readonly firstName: string;
    readonly gender: Gender;
    readonly id: string;
    readonly lastName: string;
  }>;
};
export type chDuplicatePatientsByPatientIdQuery = {
  response: chDuplicatePatientsByPatientIdQuery$data;
  variables: chDuplicatePatientsByPatientIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "patientId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "patientId",
        "variableName": "patientId"
      }
    ],
    "concreteType": "DuplicatePatientOutput",
    "kind": "LinkedField",
    "name": "ch_duplicatePatientsByPatientId",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "gender",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chDuplicatePatientsByPatientIdQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chDuplicatePatientsByPatientIdQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "959277dc198c5bb93ab2d634950ec771",
    "metadata": {},
    "name": "chDuplicatePatientsByPatientIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8475f68e159ce68424e451ee0c2264c9";

export default node;
